import React, { Component } from 'react';
import Hls from 'hls.js';

import { isBrowser } from "react-device-detect";
import api from '../api/backend';

function Timer(callback, delay) {
    var timerId, start, remaining = delay;

    this.pause = function () {
        window.clearTimeout(timerId);
        remaining -= new Date() - start;
    };

    this.resume = function () {
        start = new Date();
        window.clearTimeout(timerId);
        timerId = window.setTimeout(callback, remaining);
    };

    this.resume();
}

// ---- ค่าปรับจูนการกู้คืนเมื่อวิดีโอค้าง ----
const STALL_CHECK_INTERVAL = 2000;       // เฝ้าดูทุก 2 วินาที
const STALL_THRESHOLD_MS = 5000;         // currentTime ไม่ขยับเกิน 5 วินาที = ค้าง
const MEDIA_RECOVER_WINDOW_MS = 3000;    // กันลูป recoverMediaError ไม่จบ
const RESTALL_NUDGE_WINDOW_MS = 12000;   // ค้างซ้ำใน 12 วิ → ขยับ currentTime ข้ามจุดเสีย

export default class HLSSource extends Component {
    constructor(props, context) {
        super(props, context);
        this.hls = new Hls(this.getHlsConfig());
        this.state = { URL: '' }
        // ตัวจับเวลา/สถานะสำหรับกลไกกู้คืน
        this.recoverDecodingErrorDate = 0;
        this.recoverSwapAudioCodecDate = 0;
        this.lastPlayheadTime = 0;
        this.lastProgressAt = 0;
        this.lastStallRecoverAt = 0;
        this.resumeTime = 0;
        this.unmounted = false;
        // tracking สำหรับยิง playback event ไป backend
        this.stallStartedAt = 0;       // เวลาที่เริ่มสงสัยว่าค้าง (ms epoch)
        this.stallReported = false;    // ยิง stall ของรอบนี้ไปแล้วหรือยัง — กันยิงซ้ำ
    }

    // network info จาก browser — มีเฉพาะ Chromium ปัจจุบัน; Safari/iOS จะไม่มี → คืน ''
    getNetworkInfo = () => {
        try {
            const c = (typeof navigator !== 'undefined') &&
                (navigator.connection || navigator.mozConnection || navigator.webkitConnection);
            if (!c) return '';
            const parts = [];
            if (c.effectiveType) parts.push(`net=${c.effectiveType}`);     // 4g | 3g | 2g | slow-2g
            if (typeof c.downlink === 'number') parts.push(`down=${c.downlink}Mbps`);
            if (typeof c.rtt === 'number') parts.push(`rtt=${c.rtt}ms`);
            if (c.saveData) parts.push('saveData=1');
            return parts.join(',');
        } catch (e) { return ''; }
    }

    // ยิง event ไป backend แบบ best-effort — ห้ามทำให้ player ค้าง
    reportEvent = (eventType, extras) => {
        try {
            const { video, videoId } = this.props;
            if (!videoId) return;
            const baseDetail = (extras && extras.detail) || '';
            const netInfo = this.getNetworkInfo();
            const detail = netInfo ? (baseDetail ? `${baseDetail}|${netInfo}` : netInfo) : baseDetail;
            api.logPlaybackEvent({
                videoId,
                eventType,
                currentTime: video && isFinite(video.currentTime) ? video.currentTime : 0,
                stallDurationMs: (extras && extras.stallDurationMs) || 0,
                detail,
                userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : ''
            });
        } catch (e) { /* ignore */ }
    }

    // ยิง "abandon" ถ้า user ทิ้งหน้า/ปิด dialog ขณะยังค้างอยู่
    reportAbandonIfStalled = () => {
        if (!this.stallReported) return;
        const now = new Date().getTime();
        this.reportEvent('abandon', {
            stallDurationMs: this.stallStartedAt ? now - this.stallStartedAt : 0,
            detail: 'user_left_during_stall'
        });
        this.stallReported = false; // กันยิงซ้ำตอน unmount หลัง beforeunload
    }

    handleBeforeUnload = () => {
        this.reportAbandonIfStalled();
    }

    // config ของ hls.js: บัฟเฟอร์ล่วงหน้ามากขึ้น + ให้ retry/นัดจ์ตัวเองหลายครั้งก่อนยอมแพ้
    getHlsConfig() {
        return {
            xhrSetup: function (xhr, url) {
                xhr.setRequestHeader("Content-Language", "test");
            },
            maxBufferLength: 60,          // โหลดล่วงหน้า 60s (เดิม 30) กันเน็ตสะดุดสั้นๆ
            maxBufferHole: 0.5,
            nudgeOffset: 0.2,
            nudgeMaxRetry: 10,            // ขยับข้ามรู buffer เองได้ถึง 10 ครั้ง (เดิม 3)
            highBufferWatchdogPeriod: 2,
            manifestLoadingMaxRetry: 4,   // โหลด playlist ใหม่ได้หลายครั้ง
            levelLoadingMaxRetry: 6,
            fragLoadingMaxRetry: 8,       // โหลด segment (.ts) ใหม่ได้ถึง 8 ครั้ง (เดิม 6)
            fragLoadingRetryDelay: 1000,
            appendErrorMaxRetry: 5
        }
    }

    getUrl = () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const { src } = this.props;
        fetch(src, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
            .then(([response, json]) => {
                if (response.status === 200) {
                    console.log(json)
                    const { video } = this.props;
                    this.setState({ URL: json.url })
                    if (Hls.isSupported()) {
                        this.hls.loadSource(json.url);
                        this.hls.attachMedia(video);
                        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                            video.play();
                        });
                    }
                } else {
                    console.error('ไม่สามารถสร้างคอร์สใหม่ได้')
                }
            }).catch(() => {
                console.error('ไม่สามารถเชื่อมต่อ service ได้')
            })
    }

    tick = () => {
        const { onTick } = this.props
        if (onTick) {
            onTick()
        }
    }

    // ผูก event + เริ่มโหลด HLS เข้ากับ instance ปัจจุบัน (เรียกซ้ำได้ตอนกู้คืน)
    attachHls = () => {
        const { src, video } = this.props;
        this.hls.loadSource(src);
        this.hls.attachMedia(video);
        this.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
            console.log(event, data)
            // ถ้าเพิ่งกู้คืนจาก error ให้กลับไปตำแหน่งเดิมก่อนเล่นต่อ
            if (this.resumeTime > 0) {
                try { video.currentTime = this.resumeTime; } catch (e) { /* ignore */ }
                this.resumeTime = 0;
            }
            video.play();

            if (!isBrowser) {
                console.log("toggleFullscreen")
                video.toggleFullscreen();
            }
        });
        this.hls.on(Hls.Events.LEVEL_LOADED, (event, data) => {
            console.log('timer ', data.details.totalduration * 10 / 100 * 1000)
            this.timer = new Timer(() => {
                this.tick()
            }, data.details.totalduration * 10 / 100 * 1000);
        });
        this.hls.on(Hls.Events.DESTROYING, () => {
            console.log("Video OFF")
            if (this.timer) {
                this.timer.pause();
            }
        });
        // กู้คืนอัตโนมัติเมื่อ hls.js แจ้ง error ร้ายแรง
        this.hls.on(Hls.Events.ERROR, this.handleHlsError);
    }

    handleHlsError = (event, data) => {
        if (this.unmounted || !data.fatal) {
            // non-fatal ปล่อยให้ hls.js retry เอง / ปล่อยให้ watchdog คอยช่วย
            return;
        }
        const { video } = this.props;
        console.warn('[HLS] fatal error', data.type, data.details);
        this.reportEvent('fatal_error', {
            detail: `${data.type || 'unknown'}:${data.details || 'unknown'}`
        });
        switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
                // เน็ต/segment โหลดไม่ได้ → สั่งโหลดต่อจากตำแหน่งปัจจุบัน
                this.hls.startLoad();
                break;
            case Hls.ErrorTypes.MEDIA_ERROR:
                this.recoverMediaError();
                break;
            default:
                // กู้ด้วยวิธีปกติไม่ได้ → สร้าง instance ใหม่แล้วเล่นต่อจากจุดเดิม
                this.resumeTime = (video && video.currentTime) || 0;
                this.hls.destroy();
                this.hls = new Hls(this.getHlsConfig());
                this.attachHls();
                break;
        }
    }

    // กันลูปไม่จบ: ถ้า media error ซ้ำเร็วๆ ให้ลอง swap audio codec ก่อน recover
    recoverMediaError = () => {
        const now = new Date().getTime();
        if (!this.recoverDecodingErrorDate || (now - this.recoverDecodingErrorDate) > MEDIA_RECOVER_WINDOW_MS) {
            this.recoverDecodingErrorDate = now;
            this.hls.recoverMediaError();
        } else if (!this.recoverSwapAudioCodecDate || (now - this.recoverSwapAudioCodecDate) > MEDIA_RECOVER_WINDOW_MS) {
            this.recoverSwapAudioCodecDate = now;
            this.hls.swapAudioCodec();
            this.hls.recoverMediaError();
        } else {
            console.error('[HLS] media error ไม่สามารถกู้คืนได้');
        }
    }

    // watchdog: เฝ้าดู currentTime ถ้าไม่ขยับทั้งที่ควรเล่นอยู่ = ค้าง → กระตุ้นเอง
    startStallWatchdog = () => {
        const { video } = this.props;
        if (!video) {
            return;
        }
        this.lastPlayheadTime = video.currentTime || 0;
        this.lastProgressAt = new Date().getTime();
        this.stallInterval = window.setInterval(() => {
            if (this.unmounted || !video) {
                return;
            }
            const now = new Date().getTime();
            // ยังไม่กดเล่น / หยุดเอง / กำลัง seek / เล่นจบ → ไม่นับว่าค้าง
            if (video.paused || video.ended || video.seeking) {
                this.lastPlayheadTime = video.currentTime;
                this.lastProgressAt = now;
                // กันค่า stallDurationMs เพี้ยนเพราะรวมเวลา pause/seek
                this.stallStartedAt = 0;
                this.stallReported = false;
                return;
            }
            if (video.currentTime > this.lastPlayheadTime + 0.1) {
                // playhead เดินอยู่ = เล่นปกติ — ถ้าเคย report stall ค้างไว้ ให้ปิดด้วย recover
                if (this.stallReported) {
                    this.reportEvent('recover', {
                        stallDurationMs: this.stallStartedAt ? now - this.stallStartedAt : 0
                    });
                    this.stallReported = false;
                    this.stallStartedAt = 0;
                }
                this.lastPlayheadTime = video.currentTime;
                this.lastProgressAt = now;
                return;
            }
            // playhead ไม่ขยับนานเกินกำหนด = ค้าง
            if (now - this.lastProgressAt >= STALL_THRESHOLD_MS) {
                if (!this.stallStartedAt) {
                    this.stallStartedAt = this.lastProgressAt;
                }
                if (!this.stallReported) {
                    this.reportEvent('stall', {
                        stallDurationMs: now - this.stallStartedAt,
                        detail: `threshold=${STALL_THRESHOLD_MS}ms`
                    });
                    this.stallReported = true;
                }
                this.recoverFromStall();
                this.lastProgressAt = now; // กันยิงรัวระหว่างรอกู้คืน
            }
        }, STALL_CHECK_INTERVAL);
    }

    recoverFromStall = () => {
        const { video } = this.props;
        const now = new Date().getTime();
        console.warn('[HLS] stall detected, resuming...');
        try {
            if (this.hls) {
                this.hls.startLoad();   // กระตุ้น loader ให้ดึง segment ต่อ
            }
            // ถ้าค้างซ้ำในเวลาสั้นๆ แปลว่า segment ช่วงนี้มีปัญหา → ขยับข้ามไปเล็กน้อย
            if (this.lastStallRecoverAt && (now - this.lastStallRecoverAt) < RESTALL_NUDGE_WINDOW_MS) {
                const target = video.currentTime + 0.5;
                if (isFinite(target)) {
                    video.currentTime = target;
                }
            }
            const p = video.play();
            if (p && p.catch) {
                p.catch(() => { /* autoplay policy / ignore */ });
            }
        } catch (e) {
            console.warn('[HLS] stall recovery failed', e);
        }
        this.lastStallRecoverAt = now;
    }

    componentDidMount() {
        if (Hls.isSupported()) {
            this.attachHls();
            this.startStallWatchdog();
        }
        if (typeof window !== 'undefined') {
            // ค้าง + ปิด tab = abandon (fetch keepalive ทำให้ request ส่งออกได้ทัน)
            window.addEventListener('beforeunload', this.handleBeforeUnload);
            window.addEventListener('pagehide', this.handleBeforeUnload);
        }
        // this.getUrl()
    }


    componentWillUnmount() {
        this.unmounted = true;
        // ปิด dialog/เปลี่ยนหน้า ระหว่างกำลังค้าง = abandon เช่นกัน
        this.reportAbandonIfStalled();
        if (typeof window !== 'undefined') {
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
            window.removeEventListener('pagehide', this.handleBeforeUnload);
        }
        // หยุด watchdog + timer ก่อนทำลาย hls
        if (this.stallInterval) {
            window.clearInterval(this.stallInterval);
        }
        if (this.timer) {
            this.timer.pause();
        }
        // destroy hls video source
        if (this.hls) {
            this.hls.destroy();
        }
    }

    render() {
        return (
            <source
                src={this.props.src}
                type={this.props.type || 'application/x-mpegURL'}
            />
        );
    }
}
